<hrb-global></hrb-global>

<pre-order-banner [margin]="isOrderSummary" [product]="productName" [preOrderDate]="preOrderDate"></pre-order-banner>
<div class="main-wrapper">
  <div class="header">
    <a href="https://www.hrblock.com/tax-software/">
      <img src="assets/HRB Logo.svg" alt="HRB Logo" data-automation-action="Shopping-Cart-HRB-logo">
    </a>
    <div *ngIf="displayBreadcrumb && !displayStaticInfoOnly" class="breadcrumb-container">
      <p class="breadcrumb-content">
        <span class="breadcrumb-element" [class.breadcrumb-element-selected]="activeRoute.cart"
          [class.breadcrumb-element-completed]="activeRoute.billing" (click)="onRouteChange($event, 'cart')">
          <a routerLink="/cart" routerLinkActive="active" queryParamsHandling="merge" data-automation-action="Shopping-Cart-Cart">Cart</a>
        </span> >
        <span *ngIf="cartOrderCompleted; else elseBlock" class="breadcrumb-element"
          [class.breadcrumb-element-selected]="activeRoute.billing" (click)="onRouteChange($event, 'billing')">
          <a routerLink="/billing" routerLinkActive="active" queryParamsHandling="merge" data-automation-action="Shopping-Cart-Payment">Payment</a>
        </span>
        <ng-template #elseBlock>
          <span class="breadcrumb-element" [class.breadcrumb-element-selected]="activeRoute.billing">
            <span class="not-clickable" data-automation-label="Shopping-Cart-Payment">Payment</span>
          </span>
        </ng-template>
        >
        <span class="breadcrumb-element">
          <span class="not-clickable" data-automation-label="Shopping-Cart-Download">Download</span>
        </span>
      </p>
    </div>
  </div>

  <router-outlet></router-outlet>

  <div class="right-container" >
    <div id="fixedTop" *ngIf="!displayStaticInfoOnly" [ngClass]="{'order-container': true, '_notOrderSummary':!isOrderSummary, '_orderSummary':isOrderSummary}">
      <div [hrblockMicroAppLoader]="OrderSummary"></div>
      <ng-container *ngIf="showCoupon">
        <div [ngClass]="{'hideCoupon': !toggleText}" *ngIf="displayBreadcrumb" [hrblockMicroAppLoader]="ApplyCouponCode" ></div>
      </ng-container>
    </div>
  </div>  
</div>

<!-- This form is for nuData Tracking -->
<form class="hiddenInput">
  <input name="lastname" type="text">
</form>